"use client"
import * as React from "react"
import confetti from 'canvas-confetti';

const triggerConfetti = () => {
    confetti({
      zIndex: 999,
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });
  };

export function ConfettiExploder() {
    const [isLargeExploding, setIsLargeExploding] = React.useState(true);
    React.useEffect(() => {
        triggerConfetti();
    }, [])
    return (
        <>
        </>
    );
};